<template>
  <modal-wrapper :isOpen="showInfoModal">
    <div
      v-show="showInfoModal"
      class="customModal fade"
      v-bind:class="{ show: showInfoModal }"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h6 class="modal-title">Time Card Details</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              v-on:click="closeModal()"
            >
              &times;
            </button>
          </div>
          <div class="modal-body" style="border-bottom: 1px solid white">
            <div>
              <span
                class="font-size-sm text-uppercase font-weight-semibold timeCarDate"
                >{{ date }}</span
              >
              <span
                class="font-size-sm text-uppercase font-weight-semibold float-right"
                >{{ name }}</span
              >
              <table class="text-center mx-auto">
                <tr>
                  <th class="pr-4">
                    Start Time
                  </th>
                  <th class="pr-4">
                    End Time
                  </th>
                  <th>
                    Type
                  </th>
                  <th class="pl-4">
                    Notes
                  </th>
                </tr>
                <tbody>
                  <tr
                    v-for="(time, index) in formattedTimes"
                    v-bind:key="index"
                  >
                    <td class="pr-4">
                      {{ time.startTime }}
                    </td>
                    <td
                      v-if="
                        index == formattedTimes.length - 1 && incomplete == true
                      "
                    >
                      --
                    </td>
                    <td v-else>
                      {{ time.endTime }}
                    </td>
                    <td>
                      {{ time.type }}
                    </td>
                    <td class="pl-4">
                      <el-tooltip
                        v-show="
                          time.notes != undefined &&
                            time.notes != null &&
                            time.notes.trim() != ''
                        "
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content" v-html="time.notes"></div>
                        <i class="icon-bubble"></i>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="mt-4 float-right">
                <tr>
                  <td class="pr-4">
                    Total Hours:
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ total }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Regular Hours:
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ regularHours }}
                  </td>
                </tr>
                <tr>
                  <td>
                    OT Hours:
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ otHours }}
                  </td>
                </tr>
                <tr v-if="onCallHours > 0">
                  <td>
                    On Call Hours:
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ onCallHours }}
                  </td>
                </tr>
                <tr v-if="travelTime > 0">
                  <td>
                    Travel Time
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ travelTime }}
                  </td>
                </tr>
                <tr v-show="statTime > 0">
                  <td>
                    Stat Pay
                  </td>
                  <td v-if="incomplete">
                    --
                  </td>
                  <td v-else>
                    {{ statTime }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="modal-body">
            <div v-if="stat">
              <p style="font-weight:bold; color:#26a69a; font-size:115%">
                <el-tag type="danger" effect="dark">
                  {{ date }} is a stat holiday
                </el-tag>
              </p>
            </div>
            <div
              v-if="
                averagingAgreement &&
                  averagingAgreementData &&
                  !averagingAgreementData.deleted
              "
              class="mb-2"
            >
              <h5>Averaging Agreement:</h5>
              <el-tag
                v-if="averagingAgreementData.deleted"
                class="mb-2"
                type="danger"
                effect="dark"
              >
                NOTE: This averaging agreement has been deleted. This time card
                is now being calculated without taking the agreement into
                consideration.
              </el-tag>
              <p class="ml-4">Name: {{ averagingAgreement.name }}</p>

              <p class="ml-4">
                Overview: The agreement began on
                <el-tag type="warning" effect="dark" size="small">
                  {{
                    formatDate(
                      averagingAgreementData.timeSpans[
                        agreementTimeSpanIndex
                      ].startDate.toDate()
                    )
                  }}
                </el-tag>
                and spans over
                <el-tag type="warning" effect="dark" size="small">
                  {{ averagingAgreementData.timeFrame }}
                  {{ averagingAgreementData.timeFrameUnit }}.
                </el-tag>
                {{ name }} will receive overtime after
                <el-tag type="warning" effect="dark" size="small">
                  {{ averagingAgreementData.hoursBeforeOT }}
                </el-tag>
                hours
                {{
                  averagingAgreementData.dailyHoursBeforeOT ? 'or after' : ''
                }}
                <el-tag
                  v-if="averagingAgreementData.dailyHoursBeforeOT"
                  type="warning"
                  effect="dark"
                  size="small"
                >
                  {{ averagingAgreementData.dailyHoursBeforeOT }}
                </el-tag>
                {{
                  averagingAgreementData.dailyHoursBeforeOT
                    ? 'hours per day'
                    : ''
                }}
              </p>
              <div>
                <div class="d-flex mt-2">
                  <p class="ml-4">
                    Start Date:
                    <el-tag type="warning" effect="dark" size="small">
                      {{
                        formatDate(
                          averagingAgreementData.timeSpans[
                            agreementTimeSpanIndex
                          ].startDate.toDate()
                        )
                      }}
                    </el-tag>
                  </p>
                  <p class="ml-4">
                    Time Span:
                    <el-tag type="warning" effect="dark" size="small">
                      {{ averagingAgreementData.timeFrame }}
                      {{ averagingAgreementData.timeFrameUnit }}
                    </el-tag>
                  </p>
                </div>
                <div class="d-flex ">
                  <p class="ml-4">
                    End Date:
                    <el-tag type="warning" effect="dark" size="small">
                      {{
                        formatDate(
                          averagingAgreementData.timeSpans[
                            agreementTimeSpanIndex
                          ].endDate.toDate()
                        )
                      }}
                    </el-tag>
                  </p>

                  <p class="ml-4">
                    Hours Until Overtime:
                    <el-tag type="warning" effect="dark" size="small">
                      {{ averagingAgreementData.hoursBeforeOT }}
                    </el-tag>
                  </p>
                </div>
              </div>

              <p
                class="ml-4"
                v-if="
                  averagingAgreementData.deleted === false &&
                    incomplete === false &&
                    agreementTotalHours.current
                "
              >
                Current Status: {{ name }} has worked
                <el-tag type="warning" effect="dark" size="small">
                  {{ Number(agreementTotalHours.current).toFixed(2) }}
                </el-tag>
                hours since
                {{
                  formatDate(
                    averagingAgreementData.timeSpans[
                      agreementTimeSpanIndex
                    ].startDate.toDate()
                  )
                }}
              </p>
            </div>
            <div
              v-if="
                averagingAgreement === null ||
                  (averagingAgreementData &&
                    averagingAgreementData.deleted === true)
              "
            >
              <h5>Weekly Hours:</h5>
              <p class="ml-4" v-html="getWeeklyHoursOverview()"></p>
              <p class="ml-4" v-if="!incomplete">
                Current Status: {{ name }} has worked
                <el-tag type="warning" effect="dark" size="small">
                  {{ weeklyHours }}
                </el-tag>
                hours so far this week.
              </p>
            </div>
            <div
              v-if="
                automationsApplied &&
                  automationsLoaded &&
                  automationsData.length > 0
              "
            >
              <h5>Automations Applied:</h5>

              <p
                v-for="(automation, index) in automationsData"
                :key="index"
                class="ml-4"
              >
                - {{ automation.name }}
              </p>
            </div>
          </div>

          <div class="modal-footer d-flex justify-content-between">
            <div v-if="approved" class="d-flex">
              <i class="icon-user-check mr-1" style="color:#26a69a"></i>
              <p style="color:#26a69a">
                Approved by {{ approvedBy }} on {{ dateApproved }}
              </p>
            </div>
            <div v-else></div>

            <button
              type="button"
              class="btn btn-link"
              data-dismiss="modal"
              v-on:click="closeModal()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal-wrapper>
</template>
<script>
import { db } from '../../assets/js/firebase/db.js';
import moment from 'moment';
import modalWrapper from '../modalWrapper.vue';

export default {
  name: 'TimeCardDetails',
  props: {
    showInfoModal: Boolean,
    id: String,
    date: String,
    approved: Boolean,
    times: Array,
    name: String,
    type: String,
    dateApproved: String,
    approvedBy: String,
    lastRegTime: Number,
    otIndex: Number,
    index: Number,
    holidays: Array,
    vacation: String,
    incomplete: Boolean,
    uid: String,
    showLocation: Boolean,
    passedEditComment: Array,
    averagingAgreement: Object,
    formattedTimes: Array,
    otHours: Number,
    regularHours: Number,
    statTime: Number,
    statHoursCount: Number,
    statDaysCount: Number,
    statExemptDaysTotal: Number,
    statExemptHoursTotal: Number,
    travelTime: Number,
    onCallHours: Number,
    total: Number,
    averagingAgreementData: Object,
    agreementTotalHours: Object,
    weeklyHours: Number,
    stat: Boolean,
    automationsApplied: Array,
    agreementTimeSpanIndex: Number
  },
  components: {
    modalWrapper
  },
  data() {
    return {
      automationsData: [],
      automationsLoaded: false
    };
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    formatDate(date) {
      return moment(date).format('MMM DD, YY');
    },

    getWeeklyHoursOverview() {
      if (this.type === 'employee') {
        return `${this.name} is set to the type <span class="badge badge-primary">employee</span> and will earn overtime after
                <span class="badge badge-primary">44</span> hours.`;
      } else if (this.type === 'driver') {
        return `${this.name} is set to the type <span class="badge badge-primary">driver</span>, and so will earn overtime after <span class="badge badge-primary">50</span> hours.`;
      } else if (this.type === 'contractor') {
        return `${this.name} is set to the type <span class="badge badge-primary">contractor</span>, and so will not earn overtime.`;
      } else if (this.type === 'crusher crew') {
        return `${this.name} is set to the type <span class="badge badge-primary">crusher crew</span>, and so will earn overtime after <span class="badge badge-primary">100</span> hours over a span of <span class="badge badge-primary">two weeks</span>.`;
      }
    }
  },
  async mounted() {
    try {
      let promises = [];
      if (this.automationsApplied && this.automationsApplied.length > 0) {
        this.automationsApplied.forEach(automationID => {
          promises.push(
            db
              .collection('automations')
              .doc(automationID)
              .get()
          );
        });
        let results = await Promise.all(promises);
        results.forEach(doc => {
          if (doc.data() !== undefined) {
            this.automationsData.push(doc.data());
          }
        });
        this.automationsLoaded = true;
      }
    } catch (error) {
      console.log(error);
    }
  }
};
</script>
